import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../../partials/aside/Sidebar";
import httpService from "../../../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../../../helpers/numbers";
import linkTypeCampaigns from "../../../linkTypeCampaigns";
import helperSpinner from "../../../../../../helpers/spinner";

function AllCampaign() {
  return (
    <>
      <Sidebar openItem="manage-campaigns" activeItem="all-campaign-native" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">همه کمپین های کاربران</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">native</div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllCampaign;
